<!-- eslint-disable vue/html-self-closing -->
<template>
	<header class="header">
		<picture aria-hidden="true">
			<source 
				media="(min-width: 1024px)" 
				type="image/webp"
				srcset="/img/desktop/panther_1440x532.webp 1x, /img/desktop/panther_2880x1064.webp 2x" 
				width="1440" 
				height="522" 
			/>
			<source 
				type="image/webp"
				srcset="/img/mobile/panther_480x532.webp 1x, /img/mobile/panther_960x1064.webp 2x" 
				width="480"
				height="532"
			/>
			<img ref="pictureRef" class="picture" :class="{'show': bShow}" src="/img/mobile/panther_480x532.png" alt="" />
		</picture>
	</header>
</template>

<script setup lang="ts">
defineOptions({
    name: 'BagheraHeader',
})

const bShow = ref(false)

onMounted(() => {
	setTimeout(() => {
		bShow.value = true
	}, 500)
})
</script>

<style scoped lang="postcss">
.header {
	@apply fixed bg-black w-full h-[532px] overflow-hidden
    laptop:max-w-[1440px] laptop:mx-auto
	laptop:h-[532px];
}

.picture {
	@apply w-full h-full object-cover opacity-0 scale-100 transform-gpu transition-all duration-[2000ms];

	&.show {
		@apply transition-all duration-[2000ms] opacity-100 scale-105;
	}
}
</style>
